module.exports = __webpack_public_path__ + "images/category_lp/pc/top_PC_616ec8b46ad02bc113f09ad102e1d830.png";